'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-04-18
 */

import Vue from 'vue'
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/event-bus.js